import Replies from './Replies';

export default Replies;